var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaginationArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.145,
    height: 14.145
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 608",
    d: "M6.365.709a1 1 0 011.414 0 1 1 0 010 1.414l-4.95 4.95 4.95 4.95a1 1 0 010 1.414 1 1 0 01-1.414 0L.708 7.78a1 1 0 010-1.414z",
    fill: "#898991"
  })));
}
export default SvgPaginationArrowLeft;